<template>
    <section class="assessmentSection doorsSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">66% complete, almost there!</div>
            <div class="pageTitle">Did you know?</div>
            <div class="pageText">
                <p>
                    99% of all burglaries happen through a door. Crazy right? That’s why protecting all exterior doors is so important.
                </p>
            </div>

            <button v-if="!readyToAdd && !lead.homeDoorsQty"
                    @click="handleContinueClick"
                    class="button">
                Protect my doors
            </button>

            <transition name="fade">
                <div class="formGroup doorsFormGroup"
                     v-if="readyToAdd || lead.homeDoorsQty">
                    <label for="">How many exterior doors do you have?</label>
                    <input ref="doorInput"
                           type="number"
                           pattern="[1-9]*"
                           min="1"
                           max="99"
                           @keypress="restrictToUnsignedInteger({
                               event: $event,
                               length: 2
                           })"
                           placeholder="How many exterior doors do you have?"
                           v-model="lead.homeDoorsQty" />
                </div>
            </transition>

            <transition name="fade">
                <continue-button :to="to"
                                 :before="mixpanelTracking"
                                 v-if="lead.homeDoorsQty" />
            </transition>
        </div>
    </section>
</template>


<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            readyToAdd: false
        }
    },

    computed: {
        ...mapState(['lead', 'previousRoute']),

        to() {
            let protectionLevel = this.lead.protectionLevel

            if (this.fromAdditionalEquipment) {
                return '/assessment/system'
            }

            if (protectionLevel !== 'Essential') {
                return '/assessment/areas-of-concern-intro'
            }

            return '/assessment/loading'
        }
    },
    methods: {
        ...mapActions(['restrictToUnsignedInteger']),

        handleContinueClick() {
            this.readyToAdd = true
            Vue.nextTick(() => {
                this.$refs.doorInput.focus()
            })
        },

        mixpanelTracking() {
            let data = {
                P_doorsQuantity: this.lead.homeDoorsQty,     
            }
            mixpanel.track("completedDoorSection", data)
            mixpanel.people.set(data)
        }
        
    },
    mounted() {
        this.$Progress.set(70)
        if (this.lead.homeDoorsQty) {
            this.readyToAdd = true
        }
    },
    updated() {
        if (this.lead.homeDoorsQty) {
            this.readyToAdd = true
        }
    }
}
</script>

<style lang="css"></style>
